import React from 'react';
import { WarnModal, WarnModalProps } from '@common-fe/common-fe';

import useAutoBlockedModal from './hooks/useAutoBlockedModal';

const WarnAutoBlockedModal: React.FC<WarnModalProps> = (props) => {
  const { isClosingByClickOutsideBlocked } = useAutoBlockedModal({ visible: props?.visible });
  return (
    <WarnModal
      {...props}
      isClosingByClickOutsideBlocked={isClosingByClickOutsideBlocked || props?.isClosingByClickOutsideBlocked}
    />
  );
};

export default WarnAutoBlockedModal;
